var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 907.752,
    height: 134.076,
    viewBox: "0 0 907.752 134.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d4f8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_19431",
    x: 3.988,
    y: 33.536,
    width: 104.2,
    height: 91.749,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3a20a5",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_19432",
    x: 0,
    y: 33.533,
    width: 104.2,
    height: 91.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3a20a5",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#e4e4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d5f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8149",
    "data-name": "Rectangle 8149",
    width: 757.168,
    height: 134.075,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-full",
    transform: "translate(-199.01 -612.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11006",
    "data-name": "Group 11006",
    transform: "translate(-461 38.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8150",
    "data-name": "Rectangle 8150",
    width: 98.057,
    height: 98.057,
    rx: 10,
    transform: "translate(675 581.021)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11001",
    "data-name": "Group 11001",
    transform: "translate(692.552 602.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8184",
    "data-name": "Rectangle 8184",
    width: 14.106,
    height: 14.106,
    rx: 2,
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8185",
    "data-name": "Rectangle 8185",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(24.418)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8186",
    "data-name": "Rectangle 8186",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(48.822)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8187",
    "data-name": "Rectangle 8187",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(0 19.163)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8188",
    "data-name": "Rectangle 8188",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(24.418 19.163)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8189",
    "data-name": "Rectangle 8189",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(48.822 19.163)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8190",
    "data-name": "Rectangle 8190",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(0 40.868)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8191",
    "data-name": "Rectangle 8191",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(24.418 40.868)",
    fill: "#615de2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8192",
    "data-name": "Rectangle 8192",
    width: 14.106,
    height: 14.106,
    rx: 2,
    transform: "translate(48.822 40.868)",
    fill: "#615de2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11002",
    "data-name": "Group 11002",
    transform: "translate(675 623.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19428",
    "data-name": "Path 19428",
    d: "M15.45,45.31c5.4,34.134,25.512,40.7,25.512,40.7h-14.3c-10.114,0-11.212-5.522-11.212-15.636V45.31Z",
    transform: "translate(-15.436 -30.48)",
    fill: "#7e7ece"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.99, -49.53)",
    filter: "url(#Path_19431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19431-2",
    "data-name": "Path 19431",
    d: "M15.454,49.7c5.4,34.134,25.512,40.7,25.512,40.7H79.973a10.606,10.606,0,0,0,3.665.114c-53.78-4.077-68.2-55.641-68.2-55.641V49.7Z",
    transform: "translate(-0.45 14.66)",
    fill: "#9999e0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.99, -49.53)",
    filter: "url(#Path_19432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19432-2",
    "data-name": "Path 19432",
    d: "M15.45,34.87s14.418,51.564,68.2,55.641a22.168,22.168,0,0,1-4.276-2.117c-4.29-2.216-4.8-6.762-6.009-11-.639-2.23-.994-4.872-2.145-6.889a9.987,9.987,0,0,0-6.847-4.489c-6.165-1.349-12.458-.625-18.651-1.534A33.931,33.931,0,0,1,24.129,51.831,71.475,71.475,0,0,1,15.45,34.884Z",
    transform: "translate(-0.45 14.66)",
    fill: "#d4d4f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11003",
    "data-name": "Group 11003",
    transform: "translate(742.009 637.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19429",
    "data-name": "Path 19429",
    d: "M101.475,77.187a3.529,3.529,0,0,0-1.392-2.557L92.739,69l4.2-4.2a2.8,2.8,0,0,0-1.023-4.815L70.9,50.425a2.267,2.267,0,0,0-3.1,3.111l9.56,25.015a2.8,2.8,0,0,0,4.815,1.023l4.2-4.2L92,82.712A3.482,3.482,0,0,0,94.558,84.1h.213a3.545,3.545,0,0,0,2.5-1.065l3.168-3.168a3.489,3.489,0,0,0,1.051-2.713ZM98.62,78.1l-3.168,3.168a.99.99,0,0,1-.739.313.938.938,0,0,1-.7-.4l-7.4-9.645L80.353,77.8a.643.643,0,0,1-.369.227c-.028,0-.142-.085-.241-.355l-9.46-24.731L95.012,62.4c.27.1.355.227.355.241a.6.6,0,0,1-.227.369l-6.264,6.264,9.645,7.4a.963.963,0,0,1,.4.7.921.921,0,0,1-.313.739Z",
    transform: "translate(-59.082 -42.437)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8178",
    "data-name": "Rectangle 8178",
    width: 1.648,
    height: 7.188,
    transform: "translate(1.389 4.511) rotate(-53.49)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8180",
    "data-name": "Rectangle 8180",
    width: 1.648,
    height: 7.188,
    transform: "matrix(0.989, -0.148, 0.148, 0.989, 7.245, 0.243)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8181",
    "data-name": "Rectangle 8181",
    width: 7.188,
    height: 1.648,
    transform: "matrix(0.989, -0.148, 0.148, 0.989, 0, 10.053)",
    fill: "#fc6d43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11005",
    "data-name": "Group 11005",
    transform: "translate(690.797 583.361)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 8,
    cy: 7.5,
    rx: 8,
    ry: 7.5,
    transform: "translate(-0.401 -0.049)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 8,
    cy: 7.5,
    rx: 8,
    ry: 7.5,
    transform: "translate(50.599 -0.049)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11004",
    "data-name": "Group 11004",
    transform: "translate(694.307 574)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8182",
    "data-name": "Rectangle 8182",
    width: 8.196,
    height: 20.484,
    rx: 4.098,
    fill: "#9999e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8183",
    "data-name": "Rectangle 8183",
    width: 8.196,
    height: 20.484,
    rx: 4.098,
    transform: "translate(50.797)",
    fill: "#9999e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11007",
    "data-name": "Group 11007",
    transform: "translate(349.594 612.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10998",
    "data-name": "Group 10998",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19418",
    "data-name": "Path 19418",
    d: "M0,102.728V4.977H32.026q17.253,0,26.922,6.746t9.667,20.041a20.756,20.756,0,0,1-13.7,20.007q9.13,1.679,13.762,7.923a23.781,23.781,0,0,1,4.631,14.568q0,14.033-9.264,21.249T37.8,102.728Zm19.6-56.8H32.7q7.854,0,12.084-3.223t4.23-9.4q0-6.781-4.264-10T32.026,20.082H19.6Zm0,13.562v28.2H37.8q7.787,0,11.882-3.39t4.1-10.039q0-7.116-4.028-10.942T37.6,59.492Z",
    transform: "translate(0 2.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19419",
    "data-name": "Path 19419",
    d: "M59.239,58.909q0-16.247,9.064-26.621t25.11-10.371q16.113,0,25.244,10.339t9.13,26.654v1.41q0,16.382-9.1,26.687t-25.141,10.3q-16.113,0-25.21-10.305t-9.1-26.687Zm19.537,1.41q0,9.938,3.491,15.946t11.279,6.008q7.587,0,11.111-6.041t3.526-15.912V58.91q0-9.668-3.558-15.777t-11.212-6.11q-7.589,0-11.112,6.141T78.776,58.909Z",
    transform: "translate(23.876 8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19420",
    "data-name": "Path 19420",
    d: "M114.555,58.909q0-16.247,9.064-26.621t25.109-10.371q16.115,0,25.245,10.339T183.1,58.91v1.41q0,16.382-9.1,26.687t-25.141,10.3q-16.115,0-25.21-10.305t-9.1-26.687Zm19.537,1.41q0,9.938,3.489,15.946t11.28,6.008q7.585,0,11.111-6.041T163.5,60.319v-1.41q0-9.668-3.56-15.777t-11.212-6.109q-7.589,0-11.111,6.141t-3.524,15.745Z",
    transform: "translate(46.17 8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19421",
    "data-name": "Path 19421",
    d: "M196.6,74.322h-4.968v30.414h-19.6V0h19.6V59.417H196l17.389-27.326h22.691l-23.631,33.1L239.3,104.736H216.737Z",
    transform: "translate(69.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19422",
    "data-name": "Path 19422",
    d: "M244.838,14.7h-19.6V0h19.6Zm0,90.032h-19.6V32.093h19.6Z",
    transform: "translate(90.778 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19423",
    "data-name": "Path 19423",
    d: "M268.713,23.259l.873,10.406A26.6,26.6,0,0,1,278.515,25,23.183,23.183,0,0,1,290.4,21.916q11.009,0,17.187,7.084t6.175,22.39V95.9H294.091V51.457q0-7.789-2.72-11.043t-8.156-3.258a17.119,17.119,0,0,0-7.689,1.646,15.007,15.007,0,0,0-5.47,4.532V95.9h-19.6V23.259Z",
    transform: "translate(100.942 8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19424",
    "data-name": "Path 19424",
    d: "M303.948,60.184q0-17.186,7.453-27.728t20.947-10.54a20.629,20.629,0,0,1,10.742,2.753,24.115,24.115,0,0,1,7.922,7.854l1.545-9.264h16.851V95.566q0,14.164-9.264,21.921T334.3,125.24a49.155,49.155,0,0,1-11.682-1.511A54.219,54.219,0,0,1,311.2,119.6l3.29-14.637a45.012,45.012,0,0,0,9.3,3.256,46.1,46.1,0,0,0,10.374,1.107q8.056,0,11.849-3.356T349.8,95.5V88.92a21.937,21.937,0,0,1-7.586,6.244,22.381,22.381,0,0,1-10,2.148q-13.362,0-20.813-9.8T303.948,61.6Zm19.6,1.41q0,9.534,3.188,15t10.441,5.473a16.194,16.194,0,0,0,7.62-1.644,12.577,12.577,0,0,0,5-4.8V44.139a13.41,13.41,0,0,0-5-5.17,14.668,14.668,0,0,0-7.485-1.813,11,11,0,0,0-10.474,6.378q-3.292,6.379-3.29,16.65Z",
    transform: "translate(122.504 8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19425",
    "data-name": "Path 19425",
    d: "M426.847,61.594q0,16.113-7.452,25.916t-20.813,9.8a23.273,23.273,0,0,1-10.136-2.11,20.82,20.82,0,0,1-7.588-6.211V123.83H361.322V23.259h17.656l1.142,8.594a23.291,23.291,0,0,1,7.753-7.353,21,21,0,0,1,10.575-2.583q13.5,0,20.947,10.54t7.452,27.728Zm-19.6-1.41q0-10.272-3.423-16.65a11.172,11.172,0,0,0-10.474-6.378,14.807,14.807,0,0,0-7.554,1.813,12.949,12.949,0,0,0-4.935,5.169V75.961a12.027,12.027,0,0,0,4.935,4.7,16.636,16.636,0,0,0,7.687,1.611q7.115,0,10.44-5.573t3.324-15.1Z",
    transform: "translate(145.628 8.834)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8148",
    "data-name": "Rectangle 8148",
    width: 19.605,
    height: 104.734,
    transform: "translate(585.565 0.001)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19426",
    "data-name": "Path 19426",
    d: "M487.459,84.774a24.678,24.678,0,0,1-8.526,9,22.613,22.613,0,0,1-12.018,3.155q-11.48,0-17.959-7.788t-6.479-24.169v-42.1h19.537V65.1q0,9.536,2.584,13.06t8.024,3.524a19.583,19.583,0,0,0,8.056-1.51,13.605,13.605,0,0,0,5.5-4.466V22.873h19.6V95.515H489.54Z",
    transform: "translate(178.336 9.219)",
    fill: "#fc6d43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19427",
    "data-name": "Path 19427",
    d: "M538.333,75.761a6.758,6.758,0,0,0-3.123-5.538q-3.121-2.319-11.579-4.063-12.758-2.551-19.37-7.721a16.862,16.862,0,0,1-6.613-14.032q0-9.33,7.922-15.912t21.082-6.579q13.762,0,22.054,6.579t7.955,16.382l-.133.4H537.6a9.509,9.509,0,0,0-2.82-7.116q-2.82-2.751-8.124-2.753a11.1,11.1,0,0,0-7.453,2.35,7.309,7.309,0,0,0-2.753,5.774A6.519,6.519,0,0,0,519.3,49q2.852,2.113,11.581,3.792,13.36,2.685,19.906,7.889t6.547,14.333q0,9.8-8.392,16.045t-22.155,6.244q-14.5,0-22.928-7.351T495.835,73.21l.135-.4H513.9q.2,5.84,3.828,8.459a15.8,15.8,0,0,0,9.466,2.618q5.438,0,8.291-2.183a7.078,7.078,0,0,0,2.854-5.94",
    transform: "translate(199.835 8.834)",
    fill: "#fc6d43"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.10cfbe8084202a91f102c34f1aef9f12.svg";
export { ForwardRef as ReactComponent };